import Backbone from 'backbone'
import _ from 'lodash'
import template from './path-to-dataset-selector.hbs'
import Gardener from 'scoreboard/components/gardener'
import { Transform } from 'stream'
import FormView from 'scoreboard/components/form-view'
import i18n from 'scoreboard/components/i18n'
import datasetPaths from './dataset-paths'
import highlight from 'scoreboard/components/highlight'

const PathToDatasetSelector = Backbone.View.extend({

	/**
	 * Dialog used to choose the path to a dataset.
	 *
	 * https://github.com/SpiderStrategies/Scoreboard/issues/20543#issuecomment-507497884
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {Dataset} options.model
	 *
	 * @param {String} [options.id] the ID of an existing path that should be
	 * pre-selected
	 *
	 * @param {Number} options.datasetId the ID of the dataset we're choosing a path to
	 */
	initialize: function(options = {}) {
		this.options = options
	},

	tagName: 'form',

	className: 'path-to-dataset-selector',

	/** @type {Dataset} */
	model: null,

	render: function() {
		this.$el.empty().append(template(this.context()))

		this.setupGardener()
		this.setupFormView()

		return this
	},

	context: function() {
		let dataset = this.model.datasetsById[this.options.datasetId]
		return {
			title: i18n.get('datasets.linked.choosePathToDataset.withArg',
				`<q>${dataset.get('label')}</q>`)
		}
	},

	setupGardener: function() {
		this.gardener = new LinkedDatasetGardener({
			model: this.model,
			id: this.options.id || this.model.get('rootDatasetId'),
			forest: true,
			datasetId: this.options.datasetId
		})
		this.$('.single-tree-selector').append(this.gardener.el)
		this.gardener.render()
		this.gardener.on('select', () => this.formView.change())

		this.$('.tree-container').addClass('tree-container-light')
	},

	setupFormView: function() {
		let MyFormView = FormView.extend({
			test: this.test.bind(this)
		})
		this.formView = new MyFormView({
			el: this.el,
			submit: this.submit.bind(this),
			allowCleanSubmission: true
		})
		this.formView.start()
	},

	test: function() {
		let result = _.result(this, 'gardener.tree.selected')
		if (!result) {
			return i18n.get('datasets.pleaseChoose')
		}
		if (result.className === 'is-disabled') {
			let dataset = this.model.datasetsById[this.options.datasetId]
			return i18n.get('datasets.linked.choosePathToDataset.selectFullPath',
				highlight(dataset.get('label')))
		}
	},

	submit: function() {
		this.trigger('done', this.gardener.tree.selected())
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.gardener, this.formView], 'remove')
	}

})

const LinkedDatasetGardener = Gardener.extend({

	_url: function() {
		return `api/datasets/${this.model.id}/paths?pathToDatasetId=${this.options.datasetId}`
	},

	_treeOptions: function() {
		var treeOptions = Gardener.prototype._treeOptions.apply(this, arguments)
		treeOptions.stream = treeOptions.stream.pipe(this._transform(this.options.datasetId))
		return treeOptions
	},

	/**
	 * Adds the dataset type (used for the icon) to the stream
	 */
	_transform: function(datasetId) {
		var transform = new Transform({ objectMode: true })
		transform._transform = function (node, enc, next) {
			node.type = 'dataset'
			let lastId = datasetPaths.lastDatasetId(node.id)
			// If the last ID doesn't match the Dataset id, give it a disabled,
			//  appearance, because only the full path should be selectable. Issue #33235
			if (lastId != datasetId) {
				node.className = 'is-disabled'
			}
			this.push(node)
			next()
		}
		return transform
	}

})



export default PathToDatasetSelector

PathToDatasetSelector.__filename__ = 'datasets/edit/path-to-dataset-selector.js'
